import { Card, Typography, Box } from "@mui/material";
import { useState } from "react";
import ArrowButton from "../buttons/arrowButton";

const DashboardCard = ({ title, icon: IconSVG }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
      <Card
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          sx={{
              width: "100%",
              height: "100%",
              minHeight: {
                  xs: 130,
                  sm: 145,
                  md: 154,
              },
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              alignItems: "flex-start",
              p: {
                  xs: "16px 12px 22px",
                  sm: "18px 14px 26px",
                  md: "20px 15px 30px",
              },
              borderRadius: 2,
              bgcolor: "#E9E9E9",
              boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
              position: "relative",
              overflow: "visible",
              transition: "all 0.3s ease",
              cursor: "pointer",
              boxSizing: "border-box",

              "&:hover": {
                  "& .dashboard-arrow": {
                      transform: "rotate(45deg)",
                  },
              },
          }}
      >
      <Box
        sx={{
          width: "100%",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-start",
        }}
      >
        <Typography
          variant="h6"
          sx={{
            fontWeight: 900,
            fontSize: "24px",
            lineHeight: "110%",
            fontFamily: "Zen Maru Gothic",
            pl: "15px",
            flex: 1,
            maxWidth: "75%",
            transition: "color 0.3s ease",
            color: isHovered ? "#E5007E" : "#000000",
          }}
        >
          {title}
        </Typography>
      </Box>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          justifyContent: "flex-end",
          position: "relative",
          zIndex: 10,
        }}
      >
          {IconSVG && (
              <Box
                  className={isHovered ? "icon-hover" : ""}
                  sx={{
                      position: "absolute",
                      bottom: 0,
                      right: 0,
                      width: "clamp(78px, 22vw, 112px)",
                      height: "clamp(86px, 24vw, 124px)",
                      zIndex: 1,

                      "& svg": {
                          width: "100%",
                          height: "100%",
                          display: "block",
                      },
                  }}
              >
                  <IconSVG />
              </Box>
          )}
        <ArrowButton />
      </Box>
    </Card>
  );
};

export default DashboardCard;
